module.exports = __webpack_public_path__ + "img/p7-1.a172d040.png";